module.exports = __webpack_public_path__ + "static/media/1012560.00bb63cf.jpg";